var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatasticsKvantum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.75H19.375",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.25V0.75",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V10.75",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.75C8.3424 5.75 6.75269 6.40848 5.58058 7.58058C4.40848 8.75269 3.75 10.3424 3.75 12V18.25H16.25V12C16.25 10.3424 15.5915 8.75269 14.4194 7.58058C13.2473 6.40848 11.6576 5.75 10 5.75Z",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.75C12.0711 15.75 13.75 14.0711 13.75 12C13.75 9.92893 12.0711 8.25 10 8.25C7.92893 8.25 6.25 9.92893 6.25 12C6.25 14.0711 7.92893 15.75 10 15.75Z",
    stroke: "#575757",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatasticsKvantum);
export default __webpack_public_path__ + "static/media/statastics_kvantum.2936544ff52f19b440f869b938fa3d49.svg";
export { ForwardRef as ReactComponent };